module.exports = __webpack_public_path__ + "media/images/logo-black-ed8564d5b27b92528380bf67f12cb4a4.png";